import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {BooleanTO} from "../../classes/boolean-to";
import {ForgotPasswordTO} from "../../classes/forgot-password-to";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  private submitting = false;
  submitButtonText = 'Submit';

  errorCode: string;
  errorMessage: string;

  mode = 'password';

  forgotPasswordTO = new ForgotPasswordTO();

  passwordForm = new FormGroup({
    password: new FormControl('', Validators.required),
    passwordConfirm: new FormControl('', Validators.required),
  });

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
  }

  onCancel() {
    this.router.navigateByUrl('/#',{ skipLocationChange: false });
  }

  onChangePassword() {
    // console.log('onChangePassword');
    this.errorCode = undefined;
    this.errorMessage = undefined;

    this.forgotPasswordTO.password = this.passwordForm.value.password;

    this.submitting = true;
    this.submitButtonText = 'Submitting';

    this.authService.savePasswordChange(this.forgotPasswordTO).subscribe(response => {
      const booleanTO = response as BooleanTO;
      this.submitting = false;
      this.submitButtonText = 'Submit';
      if (booleanTO.true === true) {
        this.mode = "done";
      } else {
        this.errorCode = "DSC2U-3";
        this.errorMessage = "Password change failed.";

        if (booleanTO.message) {
          this.errorMessage = booleanTO.message;
        }
      }
    });
  }

}
